const state = {
  users: [],
  pagination: {},
  pending: false,
  errors: {},
}

const getters = {}

const actions = {
  getUsers({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      const { type } = rootState.route.meta

      commit('SET_PENDING', true)

      this.api.items
        .getItems(type, payload)
        .then(({ data }) => {
          commit('GET_USERS_SUCCESS', data)
          resolve()
        })
        .catch(error => {
          commit('GET_USERS_FAIL', error)
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING', false)
        })
    })
  },
  removeUser({ commit, rootState }, userId) {
    return new Promise((resolve, reject) => {
      const { type } = rootState.route.meta

      commit('SET_PENDING', true)

      this.api.item
        .removeItem(type, userId)
        .then(({ data }) => {
          if (data && data.errors) {
            commit('REMOVE_USER_FAIL', data.errors)
            resolve()
          }
          commit('REMOVE_USER_SUCCESS', data)
          resolve(data)
        })
        .catch(error => {
          commit('REMOVE_USER_FAIL', error)
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING', false)
        })
    })
  },
}

const mutations = {
  SET_PENDING(state, val) {
    state.pending = val
  },
  GET_USERS_SUCCESS(state, { pagination, users }) {
    state.errors = {}
    state.users = users
    state.pagination = pagination
  },
  GET_USERS_FAIL(state, errors) {
    state.errors = errors
  },
  REMOVE_USER_SUCCESS(state) {
    state.errors = {}
  },
  REMOVE_USER_FAIL(state, errors) {
    state.errors = errors
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
